/** Keep digits only for Indonesian phone fields (max 15). */
export function sanitizePhoneInput(value) {
  return String(value ?? '').replace(/\D/g, '').slice(0, 15);
}

export function formatPhoneLocal(phone) {
  let digits = String(phone ?? '').replace(/\D/g, '');
  if (digits.startsWith('62')) digits = `0${digits.slice(2)}`;
  else if (digits && !digits.startsWith('0')) digits = `0${digits}`;
  return digits;
}

export function maskPhoneDisplay(phone) {
  const local = formatPhoneLocal(phone);
  if (local.length < 8) return local || '';
  return `${local.slice(0, 4)}${'*'.repeat(Math.max(0, local.length - 8))}${local.slice(-4)}`;
}
